import { FC, ReactNode } from 'react';
import { Stack, SxProps, Theme, Typography } from '@mui/material';

import { MplButton, SkeletonBlock } from '@mopla/ui';

import { InfoWrapper } from './styled';

interface IBookingActionBarProps {
	buttonLabel: ReactNode;
	onButtonClick?: () => void;
	buttonSx?: SxProps<Theme>;
	infoLabel?: string;
	infoValue?: string;
	infoOriginalValue?: string;
	/** Skeletons the info value while it is still resolving. */
	infoLoading?: boolean;
	disabled?: boolean;
	loading?: boolean;
	variant?: 'contained' | 'outlined';
	buttonTestId?: string;
	testId?: string;
}

export const BookingActionBar: FC<IBookingActionBarProps> = ({
	infoLabel,
	infoValue,
	infoOriginalValue,
	infoLoading = false,
	buttonLabel,
	onButtonClick,
	buttonSx,
	disabled = false,
	loading = false,
	variant = 'contained',
	buttonTestId,
	testId,
}) => {
	const hasInfo = infoLabel && (infoValue || infoLoading);

	return (
		<Stack gap={2} data-testid={testId}>
			{hasInfo && (
				<InfoWrapper>
					<Typography variant="h5-sb">{infoLabel}</Typography>
					{infoLoading ? (
						<SkeletonBlock w={72} h={20} r={4} />
					) : (
						<Stack direction="row" gap={1} alignItems="center">
							{infoOriginalValue && (
								<Typography
									variant="b1-sb"
									color="solutions.600"
									sx={{ textDecoration: 'line-through' }}
								>
									{infoOriginalValue}
								</Typography>
							)}
							<Typography variant="b1-sb">{infoValue}</Typography>
						</Stack>
					)}
				</InfoWrapper>
			)}

			<MplButton
				variant={variant}
				color="primary"
				fullWidth
				onClick={onButtonClick}
				disabled={disabled || loading}
				showLoader={loading}
				testId={buttonTestId}
				sx={buttonSx}
			>
				{buttonLabel}
			</MplButton>
		</Stack>
	);
};
